//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('product', ['planSelected']),
    ...mapGetters({
      isBaseCompleteResultsPlan: 'product/isBaseCompleteResultsPlan',
      isQuizPlanResults: 'product/isQuizPlanResults',
      getPlanPriceRaw: 'product/getPlanPriceRaw',
      getTotalPrice: 'product/getTotalPrice'
    }),
    items () {
      return this.$t('allGoals.testPlans.items')
    },
    specifications () {
      return this.$t('allGoals.testPlans.completePlan.specifications')
    }
  },
  methods: {
    trackAddToCart () {
      this.trackFBPixelEvent({
        event: 'AddToCart',
        properties: {
          plan: 'base-complete-results'
        }
      })
    },
    openRemoveQuizPlanModal () {
      if (this.isBaseCompleteResultsPlan) {
        return this.$store.dispatch('product/removeBaseComplete')
      } else if (this.isQuizPlanResults) {
        this.$store.dispatch('product/selectPlanToAdd', 'base-complete')
        this.$root.$emit('bv::show::modal', 'removeQuizPlanModal')
      } else {
        this.trackAddToCart()
        this.$store.dispatch('product/selectBaseCompletePlan')
      }
    }
  }
}
